// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__37FK-","selected":"Chip_selected__3nFU8"};